import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import { Payment } from 'src/app/models/payment.model';
import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-widget-billing',
  templateUrl: './widget-billing.component.html',
  styleUrls: ['../widgets.scss', './widget-billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WidgetBillingComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  private decimalPipe = inject(DecimalPipe);

  invoiceDate$ = this.store.select(fromStore.getLatestInvoiceDate);

  payment$ = this.store.select(fromStore.getLatestPayment);

  isLoadingInvoices$: Observable<boolean>;

  isLoadingPayments$: Observable<boolean>;

  ngOnInit(): void {
    this.store
      .select(fromStore.getPaymentsLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadPayments());
        }
      });

    this.store
      .select(fromStore.getInvoicesLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadInvoices());
        }
      });
  }

  getPaymentDollars(payment: Payment): string {
    const amount = this.decimalPipe.transform(
      payment.Transaction_Amount__c,
      '1.2-2',
    );
    return `${amount.substring(0, amount.length - 3)}.`;
  }

  getPaymentCents(payment: Payment): string {
    const amount = this.decimalPipe.transform(
      payment.Transaction_Amount__c,
      '1.2-2',
    );
    return amount.substring(amount.length - 2);
  }
}
